import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { CashBank } from "../../../../components/modules/accounting/cash-bank";
import CashBankMiddleware from "../../../../middleware/modules/accounting/cash-bank";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import LogBgMiddleware from "../../../../middleware/modules/accounting/log-bg";
import LogBg from "../../../../components/modules/accounting/log-bg";
// middlewares

const mapStateToProps = ({ auth, cashbank, logBg }) => ({
  isProcessing: logBg.isProcessing,
  isError: logBg.isError,
  errorMessage: logBg.errorMessage,
  datalist: logBg.data,
  getHelperData: logBg.helperJournal,
  afterSave: logBg.afterSave,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => CashBankMiddleware.create(),
      getHelper: () => CashBankMiddleware.getHelper(),
      changeStatus: (data) => CashBankMiddleware.beforeChangeStatus(data),
      reset: () => CashBankMiddleware.resetList(),
      search: (data) => LogBgMiddleware.list(data),
      update: (data) => CashBankMiddleware.update(data),
      delete: (id, search) => CashBankMiddleware.beforeDelete(id, search),
      submit: (data, search) => CashBankMiddleware.beforeSaveNew(data, search),
    },
    dispatch
  );
};
class LogBgContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
    afterSave: PropTypes.bool,
  };

  static defaultProps = {
    afterSave:false,
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.submitItem = this.submitItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    // this.props.getHelper();
    // this.props.search(search);
  }

  submitItem() {
    this.props.submit();
  }
  render() {
    const { isProcessing, search, datalist, showModal, getHelperData,afterSave } =
      this.props;
      // if(afterSave){
      //   this.props.reset();
      //   this.props.getHelper();
      // }
    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Log BG List")}</title>
        </Helmet>
        <LogBg
          {...this.props}
          // search={search}
          // data={datalist}
          // isProcessing={isProcessing}
          // deleteItem={this.deleteItem}
          // updateItem={this.updateItem}
          // createData={this.createItem}
          // changeItem={this.changeItem}
          // getHelperData={getHelperData}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogBgContainer);
